import { Outlet } from 'react-router-dom';
import HeaderWriterComponent from '../../Header/HeaderWriter';
import BugReportFAB from '../../BugReportFAB';

const WriterLayout = () => {
  return (
    <div className="writer-layout w-full mt-[58px] min-h-[calc(100vh-58px)] bg-white">
      <HeaderWriterComponent />
      <Outlet />
      {/* Bug Report FAB - Available on all writer pages (bottom-left to avoid interface conflicts) */}
      <BugReportFAB position="bottom-left" />
    </div>
  );
};

export default WriterLayout;
